import { Component, EventEmitter, OnDestroy, OnInit, Output, Input, ViewChild, ElementRef, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { CoreUiPartialState } from '../../+state/core-ui/core-ui.reducer';
import { fetchSalesPeopleList, fetchSiteList, hasUnsavedChanges } from '../../+state/core-ui/core-ui.actions';
import { ApiService, MessageService } from '../../services';
import { ColumnApi, GridApi, GridOptions } from 'ag-grid-community';
import moment from 'moment';
import { getOrderTypes, getSalesPeopleListData, getSiteListData, getUserName } from '../../+state/core-ui/core-ui.selectors';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderType } from '@pos-app/data';
import { link } from 'fs';

@Component({
  selector: 'central-app-lib-task-form',
  templateUrl: './task-form.component.html',
  styleUrls: ['./task-form.component.scss'],
})
export class TaskFormComponent implements OnInit, OnDestroy {
  taskDetailForm: FormGroup;
  @Input() newTask: boolean;
  @Input() taskDetail: any;
  @Input() formValid: boolean;
  @Input() isInternalUser: boolean;
  @Input() isShowUser: boolean;
  @Input() orderDetails: any;

  @Output() saveTaskDetails = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();
  @Output() fetchOrder = new EventEmitter<void>();
  @ViewChild('content') boxModel: ElementRef;

  @ViewChild('siteInput') siteInput!: ElementRef;
  @ViewChild('assignedToInput') assignedToInput!: ElementRef;

  @ViewChild('orderInput') orderInput!: ElementRef;

  isChangeAssignee: boolean = false;
  isChangeOrder: boolean = false;

  initialFormValue: any;
  loggedInUser: string;
  changeAssigneeForm: FormGroup;
  changeOrderForm: FormGroup;

  siteListFiltered: any;
  salesPersonList: any;
  siteList: any;
  homeSite: string;

  searchValue: string = '';
  frameworkComponents;
  context;

  rowData = [];
  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;

  private unSubscribe$ = new Subject<void>();
  commentForm: FormGroup;
  isCloseTask: boolean;
  userSite: any;
  orderTypes: OrderType[];
  validChangeOrder: boolean = false;
  linkOrderCustomerName: string;
  validateChangeOrder: boolean = false;
  linkOrderCustomerNumber: number;
  initialFormValueChangeOrder: any;
  selectedCustomer: any;
  selectedCustomerName: string;
  preSelectedCustomerNumber = false;
  showResultUserSearchTable: boolean;

  constructor(
    private store: Store<CoreUiPartialState>,
    private messageService: MessageService,
    private modalService: NgbModal,
    private apiService: ApiService
  ) {
    this.frameworkComponents = {
      //actionRenderer: CentralTicketGridActionRendererComponent,
    };
    this.context = { componentParent: this };
    this.gridOptions = this.gridOptionsData();
  }

  ngOnInit() {
    this.initializeForm();
    this.store.dispatch(fetchSiteList());
    this.store.dispatch(fetchSalesPeopleList());
    this.subscribeToUserName();
    this.handleFormChanges();
    if (this.newTask) {
      this.apiService.fetchUserSite().subscribe((data) => {
        this.userSite = data;
        this.changeAssigneeForm.patchValue({ site: this.userSite?.sourceSiteCode }, { emitEvent: false });
      });
      this.store
        .pipe(select(getOrderTypes))
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          this.orderTypes = data;
        });
    }
  }

  ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  initializeForm() {
    this.store.pipe(select(getSiteListData), takeUntil(this.unSubscribe$)).subscribe((data) => {
      this.siteList = data.siteList;
      this.homeSite = data.homeSite;
      this.siteListFiltered = this.siteList?.filter((site) => site.siteType === 'ARB');
    });
    this.store.pipe(select(getSalesPeopleListData), takeUntil(this.unSubscribe$)).subscribe((data) => {
      this.salesPersonList = data;
    });
    this.taskDetailForm = new FormGroup({
      summary: new FormControl('', Validators.required),
      dueDate: new FormControl('', Validators.required),
      priority: new FormControl(''),
      status: new FormControl(''),
      assignedTo: new FormControl(''),
      RaisedBy: new FormControl(''),
      siteRaised: new FormControl(''),
      site: new FormControl('', Validators.required),
      siteDescription: new FormControl('', Validators.required),
      createDate: new FormControl(''),
      orderNumber: new FormControl(''),
      customerName: new FormControl(''),
      customerNumber: new FormControl(''),
      orderType: new FormControl(''),
      assignedToName: new FormControl(''),
    });

    this.changeAssigneeForm = new FormGroup({
      assignedTo: new FormControl(''),
      storeType: new FormControl('0', Validators.required),
      site: new FormControl('', Validators.required),
    });

    this.changeAssigneeForm
      .get('storeType')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unSubscribe$))
      .subscribe((val) => {
        if (val === '0') {
          this.siteListFiltered = this.siteList.filter((site: any) => site.siteType === 'ARB');
          if (this.siteList?.find((site) => site.siteCode === this.userSite?.sourceSiteCode).siteType === 'ARB') {
            this.changeAssigneeForm.get('site').setValue(this.userSite?.sourceSiteCode);
            this.changeAssigneeForm.get('assignedTo').setValue(this.taskDetailForm?.value?.assignedToName);
          } else {
            this.changeAssigneeForm.get('site').setValue('');
          }
        } else {
          this.siteListFiltered = this.siteList.filter((site: any) => site.siteType !== 'ARB');
          if (this.siteList?.find((site) => site.siteCode === this.userSite?.sourceSiteCode).siteType !== 'ARB') {
            this.changeAssigneeForm.get('site').setValue(this.userSite?.sourceSiteCode);
          } else {
            this.changeAssigneeForm.get('site').setValue('');
          }
        }
      });
    this.changeAssigneeForm
      .get('site')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unSubscribe$))
      .subscribe((val) => {
        const assigneeControl = this.changeAssigneeForm.get('assignedTo');
        if (val === this.homeSite) {
          assigneeControl.enable();
          this.taskDetailForm.get('assignedTo').enable();
        } else {
          assigneeControl.disable();
          this.taskDetailForm.get('assignedTo').disable();
          this.changeAssigneeForm.get('assignedTo').setValue('');
          this.taskDetailForm.get('assignedTo').setValue('');
        }
      });
    if (this.newTask) {
      this.initializenewTaskForm();
    } else if (this.taskDetail) {
      this.initializeExistingTaskForm();
    }
  }

  initializenewTaskForm() {
    this.initialFormValue = this.taskDetailForm.getRawValue();

    this.taskDetailForm.patchValue({
      summary: '',
      dueDate: '',
      priority: '',
      status: 'O',
      assignedTo: '',
      RaisedBy: '',
      siteRaised: '',
      site: '',
      createDate: '',
      orderNumber: this.orderDetails?.newTask ? this.orderDetails?.orderNumber || '' : '',
      customerNumber: this.orderDetails?.customerNumber || this.orderDetails?.CustomerNumber || '',
      customerName: this.orderDetails?.customerName ||  this.orderDetails?.CustomerName || '',
      orderType: this.orderDetails?.orderType || '',
      assignedToName: this.orderDetails?.assignToName || 'UNASSIGNED',
    });

    this.changeOrderForm = new FormGroup({
      newOrderNumber: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      newOrderType: new FormControl('', Validators.required),
    });

    this.taskDetailForm
      .get('priority')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unSubscribe$))
      .subscribe((val) => {
        this.taskDetailForm.patchValue({ priority: val ? 'HIGH' : '' }, { emitEvent: false });
      });

    this.changeOrderForm
      .get('newOrderNumber')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unSubscribe$))
      .subscribe((val) => {
        if (val === this.taskDetailForm.value.orderNumber) {
          this.validChangeOrder = true;
          return;
        }
        this.validChangeOrder = false;
      });

    this.changeOrderForm
      .get('newOrderType')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unSubscribe$))
      .subscribe((val) => {
        this.validChangeOrder = false;
      });

    this.taskDetailForm.valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unSubscribe$)).subscribe(() => this.compareValues());
  }

  initializeExistingTaskForm() {
    this.taskDetailForm.patchValue({
      summary: this.taskDetail.summary,
      dueDate: this.taskDetail.dueDate,
      priority: this.taskDetail.priority,
      status: this.taskDetail.status,
      assignedTo: this.taskDetail.assignedToName,
      RaisedBy: this.taskDetail.RaisedByName,
      site: this.taskDetail.siteRaisedDescription,
      siteDescription: this.taskDetail.siteAssignedDescription,
      createDate: this.taskDetail.createDate,
      orderNumber: this.taskDetail.orderNumber > 0 ? this.taskDetail.orderNumber : '',
      customerName: this.taskDetail.customerName,
      customerNumber: this.taskDetail.customerNumber,
    });

    if (this.loggedInUser) {
      this.rowData = this.taskDetail.comments.map((comment) => ({
        ...comment,
        loggedInUser: this.loggedInUser,
      }));
    }

    this.taskDetailForm
      .get('priority')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unSubscribe$))
      .subscribe((val) => {
        this.taskDetailForm.patchValue({ priority: val ? 'HIGH' : '' }, { emitEvent: false });
      });

    if (this.taskDetailForm.value.orderNumber === 0) {
      this.taskDetailForm.get('orderNumber').setValue('');
    }

    this.initialFormValue = this.taskDetailForm.getRawValue();
    this.taskDetailForm.valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unSubscribe$)).subscribe(() => this.compareValues());
  }

  onDueDateSelected(date: NgbDate) {
    //set to error if date is in selected is past date,
    const currentDate = new Date();
    const selectedDate = new Date(date.year, date.month - 1, date.day);
    const isSameDay =
      selectedDate.getDate() === currentDate.getDate() &&
      selectedDate.getMonth() === currentDate.getMonth() &&
      selectedDate.getFullYear() === currentDate.getFullYear();

    const formattedDate = date ? `${date.day}/${date.month}/${date.year}` : '';

    if (isSameDay || selectedDate >= currentDate) {
      this.taskDetailForm.get('dueDate').setValue(formattedDate);
      this.taskDetailForm.get('dueDate').setErrors(null);
    } else {
      this.taskDetailForm.get('dueDate').setErrors({ invalid: true });
    }
  }

  subscribeToUserName() {
    this.store.pipe(select(getUserName), takeUntil(this.unSubscribe$)).subscribe((data) => {
      this.loggedInUser = data;
    });
  }

  handleFormChanges() {
    this.taskDetailForm
      .get('dueDate')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unSubscribe$))
      .subscribe((val) => {
        if (val) {
          if (!moment(val, 'DD/MM/YYYY').isValid()) {
            this.taskDetailForm.get('dueDate').setErrors({ invalid: true });
            return;
          }

          const dueDate = moment(val, 'DD/MM/YYYY').toDate();
          const currentDate = new Date();
          if (dueDate < currentDate) {
            this.taskDetailForm.get('dueDate').setErrors({ invalid: true });
          } else {
            this.taskDetailForm.get('dueDate').setErrors(null);
          }
        }
      });
  }

  compareValues() {
    const currentFormValue = this.taskDetailForm.getRawValue();
    const hasChanges = JSON.stringify(currentFormValue) !== JSON.stringify(this.initialFormValue);
    this.formValid = hasChanges;
    this.store.dispatch(hasUnsavedChanges({ unsavedChanges: hasChanges }));
    this.messageService.dispatchAction(hasUnsavedChanges({ unsavedChanges: hasChanges }));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.taskDetail) {
      this.initializeForm();
    }
    if (changes.formValid) {
      this.formValid = this.formValid;
    }
  }

  changeAssigneeCheck() {
    if (this.newTask) {
      this.changeAssigneeForm?.patchValue(
        {
          assignedTo: this.changeAssigneeForm?.value?.assignedTo || this.taskDetailForm?.value?.assignedToName,
          site: this.userSite?.sourceSiteCode,
          storeType: this.siteList?.find((site) => site.siteCode === this.userSite?.sourceSiteCode).siteType === 'ARB' ? '0' : '1',
        },
        { emitEvent: true }
      );

      this.siteInput.nativeElement.blur();
      this.assignedToInput.nativeElement.blur();

      this.isChangeAssignee = true;
      this.openModalBox();
    }
  }
  changeOrderCheck() {
    if (this.newTask) {
      this.isChangeOrder = true;
      this.orderInput.nativeElement.blur();
      this.openModalBox();
    }
  }
  openModalBox() {
    this.modalService
      .open(this.boxModel, {
        windowClass: 'garage-modal',
        size: 'xl',
        backdrop: 'static',
      })
      .result.then(
        (_) => {
          this.isChangeOrder = false;
          this.isChangeAssignee = false;
        },
        (_) => {
          this.isChangeOrder = false;
          this.isChangeAssignee = false;
        }
      );
  }

  fetchOrderFromJDE() {
    this.fetchOrder.emit();
  }

  saveTask() {
    this.taskDetailForm.get('customerName').setValue(''); // Clear customer name before saving

    const { orderNumber, orderType, customerNumber } = this.taskDetailForm.value;

    if (orderNumber && orderType && !customerNumber) {
      this.apiService.checkOrderExists({ orderNumber, orderType }).subscribe((res) => {
        if (res?.ErrorFlag === '0') {
          this.taskDetailForm.get('customerNumber').setValue(res.customerNumber);
          this.emitSaveTaskDetails();
        }
      });
    } else {
      this.emitSaveTaskDetails();
    }
  }

  private emitSaveTaskDetails() {
    const updatedTaskDetails = this.getUpdatedTaskDetails();
    this.saveTaskDetails.emit(updatedTaskDetails);
  }

  private getUpdatedTaskDetails() {
    const updatedDetails = {};

    Object.keys(this.taskDetailForm.value).forEach((key) => {
      const currentValue = this.taskDetailForm.value[key];
      const initialValue = this.initialFormValue[key];

      if (currentValue !== '' && currentValue !== initialValue) {
        updatedDetails[key] = currentValue;
      }
    });

    if (this.newTask) {
      updatedDetails['status'] = 'O';
    }

    if (!this.taskDetailForm.value.priority) {
      updatedDetails['priority'] = '';
    }
    if (this.taskDetailForm.value.orderNumber === 0 || this.taskDetailForm.value.orderNumber === '') {
      updatedDetails['orderNumber'] = '';
    }

    return updatedDetails;
  }
  cancelForm() {
    this.cancel.emit();
  }

  gridOptionsData(): GridOptions {
    return {
      defaultColDef: {
        resizable: true,
        sortable: true,
        width: 150,
        cellClass: 'cell-class ag-right-aligned-cell',
        headerClass: 'header-class ag-left-aligned-header',
        cellStyle: {},
        wrapText: true,
        autoHeight: true,
      },
      columnDefs: [
        {
          headerName: 'ACTION',
          width: 100,
          cellRenderer: 'actionRenderer',
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'User',
          field: 'user',
          width: 200,
          cellStyle: { 'text-align': 'left', 'text-transform': 'none' },
          cellRenderer: (params) => {
            return `<div> ${params.value}<br/><small>${params.data.site ? `(${params.data.site})` : ''}</small></div>`;
          },
        },
        {
          headerName: 'Comments',
          field: 'text',
          flex: 1,
          cellStyle: { 'text-align': 'left', 'text-transform': 'none' },
          cellRenderer: (params) => {
            const div = document.createElement('div');
            div.innerHTML = params.value;
            return div;
          },
        },
        {
          headerName: ' Date',
          field: 'dateCreated',
          width: 230,
          cellStyle: { 'text-align': 'left', 'text-transform': 'none' },
          cellRenderer: (params) => {
            return `<div><small>Created: ${this.dateFormatter(params.data.dateCreated)}</small><br/><small>${
              params.data.dateModified ? `(Modified: ${this.dateFormatter(params.data.dateModified)})` : ''
            }</small></div>`;
          },
        },
      ],
    };
  }

  dateFormatterValue(params) {
    return moment(params.value).format('L <HH:mm>');
  }

  dateFormatter(params) {
    return moment(params).format('L <HH:mm>');
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    const sortModel = [{ colId: 'dateTime', sort: 'desc' }];
    this.gridApi.resetRowHeights();
  }

  onCellClicked(event) {
    if (event.colDef.field === 'text') {
      const rowNode = event.node;
      const isExpanded = rowNode.expanded;
      rowNode.setExpanded(!isExpanded);
    }
  }
  cancelModel() {
    this.isChangeAssignee = false;
    this.isChangeOrder = false;
    this.modalService.dismissAll();
  }

  changeAssignee() {
    if (this.newTask) {
      const assignToName = this.salesPersonList.find((el) => el.userEmail === this.changeAssigneeForm.value?.assignedTo)?.name;
      const siteAssignedDescription = this.siteList.find((el) => el.siteCode === this.changeAssigneeForm.value.site)?.siteDescription;
      this.taskDetailForm.patchValue({
        assignedTo: this.changeAssigneeForm.value.assignedTo,
        assignedToName: assignToName || 'UNASSIGNED',
        siteDescription: siteAssignedDescription,
        site: this.changeAssigneeForm.value.site,
      });
      this.modalService.dismissAll();
    }
  }

  assignToMysite() {
    if (this.newTask) {
      const siteAssignedDescription = this.siteList.find((el) => el.siteCode === this.changeAssigneeForm.value.site)?.siteDescription;

      this.changeAssigneeForm.patchValue({
        site: this.userSite?.sourceSiteCode,
        storeType: this.siteList?.find((site) => site.siteCode === this.userSite?.sourceSiteCode).siteType === 'ARB' ? '0' : '1',
        assignedTo: 'UNASSIGNED',
      });
      this.taskDetailForm.patchValue({
        siteDescription: siteAssignedDescription,
        site: this.changeAssigneeForm.value.site,
      });
    }
  }

  assignToMe() {
    if (this.newTask) {
      const assignTo = this.salesPersonList.find((el) => el.name === this.loggedInUser)?.userEmail;
      this.changeAssigneeForm.patchValue({
        assignedTo: assignTo,
        assignedToName: this.loggedInUser,
        site: this.homeSite,
        storeType: this.siteList?.find((site) => site.siteCode === this.userSite?.sourceSiteCode).siteType === 'ARB' ? '0' : '1',
      });
    }
  }
  // Method to open modal for closing task
  openCloseTicketModal() {
    this.commentForm.reset();
    this.isCloseTask = true;
    this.openModalBox();
  }

  validateForChangeOrder() {
    this.apiService
      .checkOrderExists({ orderNumber: this.changeOrderForm.value.newOrderNumber, orderType: this.changeOrderForm.value.newOrderType })
      .subscribe((res) => {
        if (res?.ErrorFlag === '0') {
          this.validChangeOrder = true;
          this.linkOrderCustomerName = res.customerName;
          this.linkOrderCustomerNumber = res.customerNumber;
        } else {
          this.validChangeOrder = false;
          this.linkOrderCustomerName = '';
          this.linkOrderCustomerNumber = 0;
        }
      });
  }

  changeOrderNumber() {
    if (this.newTask) {
      const orderType = this.orderTypes.find((el) => el.OrderTypeCode === this.changeOrderForm.value.newOrderType)?.OrderTypeCode;
      this.taskDetailForm.patchValue({
        orderNumber: this.changeOrderForm.value.newOrderNumber,
        orderType: orderType,
        customerName: this.linkOrderCustomerName,
        customerNumber: this.linkOrderCustomerNumber,
      });
      this.changeOrderForm.patchValue({
        newOrderNumber: '',
        newOrderType: '',
      });
      this.validChangeOrder = false;
    }
    this.isChangeOrder = false;
    this.modalService.dismissAll();
  }

  removeOrderLink() {
    this.taskDetailForm.patchValue({
      orderNumber: '',
      orderType: '',
      customerName: '',
      customerNumber: '',
    });
    this.changeOrderForm.patchValue({
      newOrderNumber: '',
      newOrderType: '',
    });
    this.validChangeOrder = false;
    this.linkOrderCustomerName = '';
    this.linkOrderCustomerNumber = 0;
    this.isChangeOrder = false;
    this.modalService.dismissAll();
  }

  compareValuesChangeOrdeForm() {
    const currentFormValue = this.changeOrderForm.getRawValue();
    if (JSON.stringify(currentFormValue) !== JSON.stringify(this.initialFormValueChangeOrder)?.toString()) {
      this.validateChangeOrder = true;
    } else {
      this.validateChangeOrder = false;
    }
  }

  selectCustomer(e) {
    this.selectedCustomer = e;
    if (this.selectedCustomer) {
      this.taskDetailForm.patchValue(
        {
          orderNumber: '',
          orderType: '',
          customerName: this.selectedCustomer?.customerName,
          customerNumber: this.selectedCustomer?.customerNumber,
        },
        { emitEvent: true }
      );
    }
  }

  isFocus(e) {
    this.showResultUserSearchTable = true;
    e.target.select();
  }
}
